/**
 * Ham ilan açıklamasını temizler ve görüntülenebilir hale getirir.
 * @param {string} description
 * @returns {string}
 */
export function formatListingDescription(description) {
  if (!description || typeof description !== 'string') return '';
  return description.trim();
}

/**
 * Açıklamanın gösterilip gösterilmeyeceğine karar verir.
 * Başlıkla birebir aynıysa veya çok kısaysa göstermez.
 * @param {string} description
 * @param {string} title
 * @returns {boolean}
 */
export function isDisplayableDescription(description, title) {
  if (!description || typeof description !== 'string') return false;
  const trimmed = description.trim();
  if (trimmed.length < 10) return false;
  if (title && trimmed === title.trim()) return false;
  return true;
}
